var map = {
	"./X33-Mall_small.jpg": 877,
	"./all-active.svg": 878,
	"./all.svg": 879,
	"./apple-watch.png": 880,
	"./b-headphone.png": 881,
	"./coin.svg": 882,
	"./delete-btn.svg": 883,
	"./iphone-pink.png": 884,
	"./love-active.svg": 885,
	"./love.svg": 886,
	"./mobile-bg.jpg": 887,
	"./price-high-active.svg": 888,
	"./price-high.svg": 889,
	"./price-low-active.svg": 890,
	"./price-low.svg": 891,
	"./shopping-cart.svg": 892,
	"./star.svg": 893,
	"./x33mall-banner-cn.jpg": 894,
	"./x33mall-banner-id.jpg": 895,
	"./x33mall-banner-ms.jpg": 896,
	"./x33mall-banner.jpg": 897
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 150;